<template lang="pug">
  v-container
    v-row
      v-col
        v-alert(
          type="info"
          :color="$theme.background.color") Montant du don
          strong  {{ $money(amount) }}
          | .
    v-row
      v-col(:cols="12")
        v-text-field(
          ref='cardNumber'
          v-bind="stripe.state.cardNumber"
          placeholder="#### #### #### ####"
          filled
          label="Numéro de la carte")
      v-col(:cols="6")
        v-text-field(
          ref="cardExpiry"
          v-bind="stripe.state.cardExpiry"
          placeholder="mm / aa"
          filled
          label="Date d'expiration")
      v-col(:cols="6")
        v-text-field(
          ref="cardCvc"
          v-bind="stripe.state.cardCvc"
          placeholder="###"
          filled
          label="CVC")
</template>

<script>
import { page } from '@iez/core'
import createOnClick from '@iez/lib/create-on-click/'
import useStripe from '@iez/lib/use-stripe/'
import createRefs from '@iez/lib/create-refs/'
import { injectRouteState } from '@iez/core'
import { toRefs } from '@vue/composition-api'
import router from '@iez/core/router/'
import data from '@iez/lib/data/'

const route = {
  name: `DonateToAssociationPayment`,
  path: `/donate-to-assocation-payment/`
}

export default {
  ...route,

  setup () {
    const routeState = injectRouteState({
      name: `DonateToAssociation`
    })

    page.topBar.set({
      title: `Finalisation du don`
    })

    const stripeRefs = createRefs([
      'cardNumber',
      'cardExpiry',
      'cardCvc'
    ])
    const stripe = useStripe({
      objs: stripeRefs,
      purchase: routeState.amount
    })

    page.bottomAction.set(
      () => stripe.state.complete
        ? {
        action: {
          label: `Finaliser`,
          onClick: createOnClick({
            pay: async () => {
              const { paymentId, error } = await stripe.pay()
              if (error) {
                page.bottomSnackbar.set({
                  content: `Une erreur est survenue. Paiement refusé.`
                })
              } else {
                await data.set({
                  root: `donations`,
                  items: [{
                    paymentId,
                    associationId: routeState.associationId
                  }],
                  fields: [
                    `id`
                  ]
                })
                router.push({
                  name: `DonateToAssociationSuccess`
                })
              }
            }
          })
        }
      } : null
    )

    return {
      ...stripeRefs,
      stripe,
      ...toRefs(routeState)
    }
  }
}
</script>
